
// 弹窗类型优先级队列， 队列的顺序决定了弹窗的显示优先级
export const POP_TYPE_RANK = [
    'claim-agent-modal',
    // 'agent-create-dialog-new',
    'consult-improve-dialog',
    'agent-create-dialog',
    'law-header-bjh-dialog',
    'free-vip-dialog',
    'ui-carousel'
];

export const POP_PAGE_NEED_SPECIAL_TASK_MAP = {
    '/fp/account/index/consult': true
};

export const POP_PAGE_NEED_SPECIAL_TASK_ROUTE_MAP = {
    '/consult': true
};
